import React, { Component } from 'react';
import Text from 'react-format-text';
import {
  Comment,
  Header,
  Icon,
  Segment,
} from 'semantic-ui-react';

import { Gallery as ReactGallery } from '../../ReactGridGallery';
import {
  CustomContainer,
} from '../../common';
import {
  PersonaLink,
  SchoolLink,
} from '../../Links';
import {
  checkImageURL,
  formatTimestamp,
  getUrls,
  getUserAvatar,
  parseImgurURL,
} from '../../Utils';

interface DcardCommentProps {
  anonymous?: boolean;
  content: string;
  createdAt: string;
  department?: string;
  floor: number;
  gender: 'M' | 'F';
  host?: boolean;
  id: string;
  likeCount: number;
  persona?: {
    id: string;
    nickname?: string;
  };
  school?: {
    id: string;
    name: string;
  };
}

interface DcardCommentState {
  urls: string[];
}

class DcardComment extends Component<DcardCommentProps, DcardCommentState> {
  state = {
    urls: [],
  }

  componentDidMount() {
    const {
      content,
    } = this.props;

    const urls = getUrls(content);
    const validURLS = urls
      .map((url) => parseImgurURL(url))
      .filter((url) => checkImageURL(url));

    this.setState({
      urls: validURLS,
    });
  }

  render() {
    const {
      content,
      createdAt,
      department,
      floor,
      gender,
      host,
      likeCount,
      persona,
      school,
    } = this.props;

    const {
      urls,
    } = this.state;

    return content && (
      <div>
        <Comment>
          <Comment.Avatar
            src={getUserAvatar((school && school.id) || (persona && persona.id) || '')}
          />
          <Comment.Content>
            <span style={{ color: '#1abc9c' }}>
              <b>B{floor} </b>
            </span>
            {
              host && (
                <span><b>原PO - </b></span>
              )
            }
            {
              school && (
                <SchoolLink id={school.id}>
                  <Comment.Author as="a">
                    {school.name}
                    {' '}
                    {department}
                  </Comment.Author>
                </SchoolLink>
              )
            }
            {
              persona && (
                <PersonaLink id={persona.id}>
                  <Comment.Author as="a">
                    {persona.nickname ?? persona.id}
                  </Comment.Author>
                </PersonaLink>
              )
            }
            {
              gender === 'M' ? (
                <Icon name="male" color="blue" />
              ) : (
                <Icon name="female" color="pink" />
              )
            }
            <Comment.Metadata>
              <div>
                {formatTimestamp(createdAt)}
              </div>
              <div>
                <Icon name="heart" />
                {likeCount}
              </div>
            </Comment.Metadata>
            <Comment.Text>
              <Text>
                {content}
              </Text>
              {urls.length > 0 && (
                <picture>
                  <ReactGallery
                    enableImageSelection={false}
                    images={urls.map(url => ({
                      src: url,
                      width: 1,
                      height: 1
                    })) as any}
                  />
                </picture>
              )}
            </Comment.Text>
          </Comment.Content>
        </Comment>
      </div>
    );
  }
}

interface CommentsProps {
  data: Array<{
    anonymous?: boolean;
    content: string;
    created_at: string;
    department?: string;
    floor: number;
    gender: 'M' | 'F';
    host?: boolean;
    id: string;
    like_count: number;
    school_meta?: {
      id: string;
      name: string;
    };
    persona_meta?: {
      id: string;
      nickname?: string;
    };
  }>;
  total: number;
  isMobile: boolean;
}

export default ({ data, total, isMobile }: CommentsProps) => {
  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }
  
  return (
    <CustomContainer>
      <Header
        as={isMobile ? 'h3' : 'h2'}
        attached="top"
      >
        共
        {' '}
        {total}
        {' '}
        則回應
      </Header>
      <Segment attached>
        <Comment.Group size={isMobile ? 'small' : 'large'}>
          {data.map((comment) => (
            <DcardComment
              anonymous={comment.anonymous}
              content={comment.content}
              createdAt={comment.created_at}
              department={comment.department}
              gender={comment.gender}
              host={comment.host}
              id={comment.id}
              floor={comment.floor}
              key={comment.id}
              likeCount={comment.like_count}
              school={comment.school_meta} // (TODO) -> will be renamed to school soon
              persona={comment.persona_meta} // (TODO) -> will be renamed to persona soon
            />
          ))}
        </Comment.Group>
      </Segment>
    </CustomContainer>
  );
};
